export const labelToRate = (rate: number, speedNormalText: string) => {
  if (rate === 1) {
    return `${rate.toFixed(1)}x - ${speedNormalText}`;
  }

  if (Number.isInteger(rate)) {
    return `${rate.toFixed(1)}x`;
  }

  return `${rate.toFixed(2)}x`;
};
